import { usePublicationByZoneLibbyCall } from "./PublicationByZoneBusinessGenerated";

export const usePublicationNameByZone = (zone: string) => usePublicationByZoneLibbyCall<string>({ methodName: "getNameByZone", params: [zone] });
